<template>
  <fragment>
    <a class="mobile-header-login-btn" @click="loginRedirect">
      <img :src="$config.images['userAvatar']" />
      <span v-html="$config.strings['header-mobile-btn']" />
    </a>
  </fragment>
</template>

<script>
export default {
  name: 'login-menu',
  methods: {
    loginRedirect () {
      location.href = this.$config.urls.login_url
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-header-login-btn {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: auto;

  & > img {
    display: inline;
    width: 25px;
    height: 25px;
  }

  & > span {
    padding-left: 5px;
    text-transform: uppercase;
    color: var(--secondary);
  }
}
</style>
